/* src/app/modules/expense/advancepayment/advancePayment-form-item.component.css */
.fi-dialog-header {
  display: flex !important;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.25rem 0.75rem !important;
  margin: 0 !important;
  border-bottom: 1px solid #e5e7eb;
}
.fi-dialog-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 1.05rem;
  font-weight: 600;
  color: #1a1d23;
}
.fi-dialog-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba(227, 253, 100, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
}
.fi-dialog-icon mat-icon {
  color: #e3fd64;
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.fi-close-btn {
  color: #9ca3af;
}
.fi-content {
  padding: 1.25rem 1.25rem 0.5rem !important;
  max-height: 70vh;
}
.fi-prefix-icon,
.fi-suffix-icon {
  font-size: 18px;
  color: #9ca3af;
}
.fi-taxes-section {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 0.75rem 1rem;
  background: #fafafa;
}
.fi-taxes-label {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.8rem;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 0.6rem;
}
.fi-taxes-label mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  color: #9ca3af;
}
.fi-chips-wrap {
  margin-top: 0.5rem;
}
.fi-total-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background:
    linear-gradient(
      135deg,
      #fff8e6 0%,
      #fff3d6 100%);
  border: 1px solid #e3fd64;
  border-radius: 8px;
  padding: 0.75rem 1.25rem;
}
.fi-total-label {
  font-size: 0.9rem;
  font-weight: 600;
  color: #92400e;
}
.fi-total-value {
  font-size: 1.3rem;
  font-weight: 700;
  color: #92400e;
  letter-spacing: -0.01em;
}
.fi-actions {
  display: flex !important;
  justify-content: flex-end;
  align-items: center;
  padding: 0.75rem 1.25rem 1rem !important;
  border-top: 1px solid #e5e7eb;
  gap: 0.5rem;
}
.fi-btn-save {
  background-color: #e3fd64 !important;
  color: rgba(0, 0, 0, .85) !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
}
@media (max-width: 560px) {
  .fi-content {
    padding: 1rem !important;
  }
}
/*# sourceMappingURL=advancePayment-form-item.component.css.map */
